/**
 * A11y Action 命名空间
 */
export const a11yActionNamespace = 'fanfanlo/javajs/v1/project/components/actions/a11y/'
